import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home/index.vue'
import gameDetail from '../views/gameDetail/index.vue'

Vue.use(VueRouter)

const routes = [
    {
    path: '/',
    redirect: "/home"
  },
  {
    path: '/home',
    name: 'home',
    component: home
  },
  {
    path: '/game-detail',
    name: 'gameDetail',
    component: gameDetail
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
